<template>
  <div v-if="categories && categories.length" class="home-categories sides-padding">
    <div class="container">
      <div class="home-categories__inner">
        <h2 class="main-color">Популярные категории</h2>
        <div class="home-categories__list">
          <router-link
            v-for="(item, i) in categories"
            :key="i"
            :to="{ name: 'catalog', params: { id: item.id } }"
            class="home-categories__item"
          >
            <span class="home-categories__item-title">{{ item.title }}</span>
            <div v-if="item.head_img" class="ratio-container">
              <ImgComponent class="home-categories__item-image" :head_img="item.head_img" quality="60" />
            </div>
          </router-link>
        </div>
        <div class="home-categories__cols">
          <div class="home-categories__col">
            <router-link
              v-if="categories[0]"
              :to="{ name: 'catalog', params: { id: categories[0].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[0].title }}</span>
              <div v-if="categories[0].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[0].head_img"
                  quality="60"
                />
              </div>
            </router-link>
            <router-link
              v-if="categories[1]"
              :to="{ name: 'catalog', params: { id: categories[1].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[1].title }}</span>
              <div v-if="categories[1].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[1].head_img"
                  quality="60"
                />
              </div>
            </router-link>
          </div>
          <div class="home-categories__col">
            <router-link
              v-if="categories[2]"
              :to="{ name: 'catalog', params: { id: categories[2].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[2].title }}</span>
              <div v-if="categories[2].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[2].head_img"
                  quality="60"
                />
              </div>
            </router-link>
          </div>
          <div class="home-categories__col">
            <router-link
              v-if="categories[3]"
              :to="{ name: 'catalog', params: { id: categories[3].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[3].title }}</span>
              <div v-if="categories[3].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[3].head_img"
                  quality="60"
                />
              </div>
            </router-link>
            <router-link
              v-if="categories[4]"
              :to="{ name: 'catalog', params: { id: categories[4].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[4].title }}</span>
              <div v-if="categories[4].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[4].head_img"
                  quality="60"
                />
              </div>
            </router-link>
          </div>
          <div class="home-categories__col">
            <router-link
              v-if="categories[5]"
              :to="{ name: 'catalog', params: { id: categories[5].id } }"
              class="home-categories__item"
            >
              <span class="home-categories__item-title">{{ categories[5].title }}</span>
              <div v-if="categories[5].head_img" class="ratio-container">
                <ImgComponent
                  class="home-categories__item-image"
                  :head_img="categories[5].head_img"
                  quality="60"
                />
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopularCategoriesComponent",
  props: {
    categories: Array,
  },
};
</script>

<style lang="stylus">
//@import "~@/styles/mixins/ratio.styl"
.home-categories {
  &__list {
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-gap 30px
    +above(1201px) {
      display none
    }
    +below(800px) {
      grid-template-columns repeat(2, 1fr)
    }
    +below(540px) {
      grid-gap 20px
    }
  }

  &__cols {
    display grid
    grid-template-columns repeat(4, 1fr)
    grid-gap 30px
    +below(1200px) {
      display none
    }
  }

  &__col {
    display grid
    grid-gap 30px

    &:nth-child(2n) {
      .home-categories__item {
        height 100%
      }
    }
  }

  &__item {
    ratio(303, 180)
    position relative
    overflow hidden
    background var(--gray)
    border-radius var(--main_radius)
    padding 30px
    height 180px
    cursor: pointer;
    transition var(--transition)
    +below(900px) {
      padding 20px
    }
    +below(840px) {
      height 140px
    }
    +below(480px) {
      border-radius var(--small_radius)
      padding 10px
    }
    +below(440px) {
      height 100px
    }

    .ratio-container {
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      z-index 0
    }

    &:before {
      content ''
      position absolute
      top 0
      left 0
      right 0
      height 60%
      background linear-gradient(180deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 100%)
      z-index 1
      pointer-events none
    }

    &-title {
      position relative
      font-weight: 700;
      font-size: 1.125em
      line-height: 140%;
      color: #fff
      text-shadow 0 1px 4px rgba(0, 0, 0, 0.35)
      z-index 2
      +below(900px) {
        font-size 1em
      }
      +below(440px) {
        font-size: 0.875em
        line-height: 16px;
      }
    }

    &-image {
      width 100%
      height 100%
      max-width 100%
      max-height none
      object-fit cover
      object-position center
    }
  }
}
</style>
